import { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
// import ProtectedRoute from './components/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import Home from './pages/Home';
import IndividualSignUp from './pages/IndividualSignUp';
import CorporateSignUp from './pages/CorporateSignUp';
import PartnerSignUp from './pages/PartnerSignUp';
import ProductList from './pages/ProductList';
import SearchList from './pages/ProductList/SearchList';
import ProductListBrandWise from './pages/ProductListBrandWise';
import ProductDetails from './pages/ProductDetail';
import MyReturnDetails from './pages/MyReturnDetail';
import 'react-toastify/dist/ReactToastify.css';
import OrderDetailsPage from './pages/OrderDetail/OrderDetailsPage';
import TemplateDetailsPage from './pages/TemplateDetail/TemplateDetailsPage';
import ProductMappingPage from './pages/ProductMappingPage/ProductMappingPage';
import ShoppingCartInfoPage from './pages/ShoppingCart/ShoppingCartInfoPage';
import ShoppingCartTabs from './components/CartTabs/ShoppingCartTabs';
import ShoppingOrderConfirmationPage from './pages/ShoppingCart/ShoppingOrderConfirmationPage';
import PendingOrder from './pages/PendingOrder/PendingOrder';
import CatalogDetailsPage from './pages/CatalogDetailsPage/CatalogDetailsPage';
import DeliveryDetailPage from './pages/DeliveryDetailPage';
import CostCenterDetailsPage from './pages/CostCenterDetailsPage/CostCenterDetailsPage';
import ContractDetailsPage from './pages/ContractDetailsPage/ContractDetailsPage';
import BudgetDetailsPage from './pages/BudgetDetails/BudgetDetailsPage';
import InvoiceDetailsPage from './pages/InvoiceDetail/InvoiceDetailsPage';
import ReportDetailPage from './pages/ReportDetailPage/ReportDetailPage';
import CorporateGroupDetailsPage from './pages/CorporateGroupDetailsPage';
import MyRequestPage from './pages/MyRequestPage';
import MyRequestDetailsPage from './pages/MyRequestDetailsPage/MyRequestDetails';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword/ResetPassword.jsx';
import Login from './pages/Login/Login.jsx';
import Signup from './pages/Signup/Signup.jsx'
import Logout from './pages/Logout/Logout.jsx';
import MyAccount from './pages/MyAccount/MyAccount.jsx';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail.jsx';
import FooterPages from './pages/FooterPages/FooterPages';
import HelpDesk from './pages/Helpdesk/Helpdesk';
import FAQS from './pages/FAQS/FAQS';
import SendUsMessage from './pages/SendUsMessagePage';
import Contactus from './pages/Contactus';
import 'devextreme/dist/css/dx.light.css';
import PunchoutLogin from './pages/Punchout/PunchoutLogin.jsx'
import PunchoutOrderDetailsPage from './pages/Punchout/PunchoutOrderDetailPage.jsx'

function App() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <>
            <ToastContainer />
            <Routes>
                {/* {!isAuthentication() && (
                    <>
                        <Route path="/login" element={<Login />} />
                    </>
                )} */}
                {/* <Route exact path='/profile' element={<ProtectedRoute />}>
                    <Route exact path='/profile' element={<ProfileAccount />} />
                </Route> */}
                <Route path='*' element={<Home />} />
                <Route path='/product-detail' element={<ProductDetails />} />
                <Route path='/individual-sign-up' element={<IndividualSignUp />} />
                <Route path='/corporate-sign-up' element={<CorporateSignUp />} />
                <Route path='/partner-sign-up' element={<PartnerSignUp />} />
                <Route path='/order-details' element={<OrderDetailsPage />} />
                <Route path='/template-details' element={<TemplateDetailsPage />} />
                <Route path='/shopping-cartInfo' element={<ShoppingCartInfoPage />} />
                <Route path='/shopping-cart' element={<ShoppingCartTabs />} />
                <Route path='/shopping-cart-shipping' element={<ShoppingCartTabs />} />
                <Route path='/shopping-cart-info' element={<ShoppingCartTabs />} />
                <Route path='/shopping-cart-approval-info' element={<ShoppingCartTabs />} />
                <Route path='/shopping-order-confirm' element={<ShoppingOrderConfirmationPage />} />
                <Route path='/pending-order' element={<PendingOrder />} />
                <Route path='/report-detail' element={<ReportDetailPage />} />
                <Route path='/contract-details' element={<ContractDetailsPage />} />
                <Route path='/catalog-details' element={<CatalogDetailsPage />} />
                <Route path='/return-details' element={<MyReturnDetails />} />
                <Route path='/budget-details' element={<BudgetDetailsPage />} />
                <Route path='/invoice-details' element={<InvoiceDetailsPage />} />
                <Route path='/costcenter-details' element={<CostCenterDetailsPage />} />
                <Route path='/corporate-group-details' element={<CorporateGroupDetailsPage />} />
                <Route exact path='/forgot-password' element={<ForgotPassword />} />
                <Route path='/reset-password' element={<ResetPassword />} />
                <Route path='/verify-email' element={<VerifyEmail />} />
                <Route path='/my-request' element={<MyRequestPage />} />
                <Route path='/my-request-details' element={<MyRequestDetailsPage />} />
                <Route path='/delivery-order-details' element={<DeliveryDetailPage />} />
                
                <Route path='/signup' element={<Signup />} />
                <Route path='/login' element={<Login />} />
                <Route path='/logout' element={<Logout />} />
                
                <Route path='/category' element={<ProductList/>} />
                <Route path='/search' element={<SearchList/>} />
                <Route path='/brand' element={<ProductListBrandWise/>} />
                <Route path='/my-account' element={<MyAccount />} />
                <Route path='/page' element={<FooterPages />} />
                <Route path='/helpdesk' element={<HelpDesk />} />
                <Route path='/faqs' element={<FAQS />} />
                <Route path='/send-us-message' element={<SendUsMessage />} />
                <Route path='/productMapping' element={<ProductMappingPage />} />
                <Route path='/contactus' element={<Contactus/>} />
				<Route path='/punchout' element={<PunchoutLogin/>} />
                <Route path='/punchout-orderdetails' element={<PunchoutOrderDetailsPage/>} />
            </Routes>
        </>
    );
}

export default App;
